import React, { CSSProperties } from 'react';
import { colors } from 'styleguide/colors';
import styled from 'styled-components';
import { Card } from 'styleguide/Card';
import { observer } from 'mobx-react-lite';
import { P1, P2, P3 } from 'styleguide/Texts';
import { StyledRadioButton } from './RadioButton';
import { t } from 'translations/t';

const Content = styled.div`
  margin: 0 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const FlexRow = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

const FlexColumn = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const CrossedOutPrice = styled(P2)`
  text-decoration: line-through;
`;

interface PaywallCardProps {
  planName: string;
  description: string;
  hint?: string;
  price: string;
  discountedPrice?: string;
  selected: boolean;
  style?: CSSProperties;
  onClick: () => void;
}

export const PaywallCard = observer(
  ({
    planName,
    description,
    hint,
    price,
    discountedPrice,
    selected,
    style,
    onClick,
  }: PaywallCardProps) => (
    <div
      style={{
        cursor: 'pointer',
        width: '100%',
        maxWidth: 470,
        height: 96,
        borderRadius: 8,
        borderStyle: 'solid',
        borderWidth: 2,
        ...(selected
          ? {
              borderColor: colors.primary,
            }
          : {
              borderColor: colors.transparent,
            }),
        ...style,
      }}
    >
      <Card
        style={{
          height: '100%',
          backgroundColor: colors.transparent,
          ...(selected
            ? {
                borderColor: colors.transparent,
              }
            : {}),
        }}
        onClick={onClick}
      >
        <Content>
          <FlexRow>
            <FlexColumn>
              <StyledRadioButton checked={selected} onChange={() => null} />
            </FlexColumn>
            <FlexColumn style={{ flex: 1, marginInlineStart: 10 }}>
              <FlexRow>
                <div style={{ display: 'inline-flex', alignItems: 'center', marginBottom: 10 }}>
                  <P1 style={{ color: colors.yellow, marginInlineEnd: 6 }}>
                    {t('web.paywall.global.pro')}
                  </P1>
                  <P3 style={{ color: colors.primary, fontWeight: 600 }}>{planName}</P3>
                </div>
                <div style={{ marginInlineStart: 'auto' }}>
                  {!!hint && (
                    <P3
                      style={{
                        marginInlineStart: 20,
                        marginTop: -10,
                        color: colors.primary,
                        backgroundColor: colors.primary100,
                        fontSize: 12,
                        paddingTop: 4,
                        paddingBottom: 4,
                        paddingInlineStart: 8,
                        paddingInlineEnd: 8,
                        borderRadius: 6,
                        letterSpacing: -0.2,
                      }}
                    >
                      {hint}
                    </P3>
                  )}
                </div>
              </FlexRow>
              <FlexRow>
                {discountedPrice ? (
                  <>
                    <CrossedOutPrice>{price}</CrossedOutPrice>
                    <P1 style={{ marginInlineStart: 4 }}>{discountedPrice}</P1>
                  </>
                ) : (
                  <P1>{price}</P1>
                )}
                <P3 style={{ marginInlineStart: 'auto' }}>{description}</P3>
              </FlexRow>
            </FlexColumn>
          </FlexRow>
        </Content>
      </Card>
    </div>
  ),
);
